import { useState, useEffect } from "react";
import { XIcon } from "@heroicons/react/outline";

const AddPixelModal = ({
  isOpen,
  onClose,
  onSubmit,
  allPixels = [],
  selectedExisting = [],
}) => {
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (!isOpen) {
      setSelected([]);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleAdd = (pixel) => {
    if (selected.find((p) => p.id === pixel.id)) return;
    setSelected((prev) => [...prev, pixel]);
  };

  const handleRemove = (id) => {
    setSelected((prev) => prev.filter((p) => p.id !== id));
  };

  const handleSubmit = () => {
    onSubmit(selected);
  };

  const availablePixels = allPixels.filter(
    (p) => !selectedExisting.some((sp) => sp.id === p.id)
  );

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="w-full max-w-md bg-slate-900 border border-white/10 rounded-xl">

        {/* HEADER */}
        <div className="flex justify-between px-6 py-4 border-b border-white/10">
          <h2 className="text-white font-semibold">Add Pixels</h2>
          <button onClick={onClose}>
            <XIcon className="w-5 h-5 text-slate-400" />
          </button>
        </div>

        {/* BODY */}
        <div className="px-6 py-5 space-y-4">

          {/* DROPDOWN */}
          <select
            onChange={(e) => {
              const pixel = availablePixels.find(
                (p) => p.id === Number(e.target.value)
              );
              if (pixel) handleAdd(pixel);
            }}
            className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white"
          >
            <option value="">Select Pixel</option>
            {availablePixels.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name}
              </option>
            ))}
          </select>

          {/* SELECTED LIST */}
          <div className="space-y-2">
            {selected.map((p) => (
              <div
                key={p.id}
                className="flex items-center justify-between bg-slate-800 px-3 py-2 rounded-lg text-sm"
              >
                <span>{p.name}</span>

                <button
                  onClick={() => handleRemove(p.id)}
                  className="text-red-400 hover:text-red-500"
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* FOOTER */}
        <div className="flex justify-end gap-3 px-6 py-4 border-t border-white/10">
          <button onClick={onClose} className="text-slate-400">
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            className="bg-pink-600 px-4 py-2 rounded text-white"
            disabled={!selected.length}
          >
            Add
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddPixelModal;